export const FEATURE_PACKAGES: Record<string, string[]> = {
  'Basic Feature Package': [
    'full-academy',
    'skill-should-forward-skill-service',
    'builder-pro',
    'group-chat',
    'curriculum-collaboration',
    'microsoft-onedrive-integration',
    'bookmarks',
  ],
  'Admin Reports': ['admin-reports'],
  'District Curriculum Editors': ['curriculum-editors'],
  'AI Features': [
    'ai-question-feedback',
    'ai-auto-scoring',
    'ai-practice-problems',
    'ai-lesson-clipper',
    'ai-curriculum-coach',
  ],
  Atlas: ['atlas'],
}

const matchingOrMissingPackages = (
  featureList: { name: string }[],
  matching: boolean,
) => {
  const currentFeatureNames = featureList.map((f) => f.name)
  return Object.entries(FEATURE_PACKAGES)
    .filter(([_packageName, packageFeatures]) => {
      const currentSet = new Set(currentFeatureNames)
      const relevantFeatures = packageFeatures.filter((f: string) =>
        matching ? currentSet.has(f) : !currentSet.has(f),
      )
      return relevantFeatures.length > 0
    })
    .map((featurePackage) => featurePackage[0])
}

export const findMissingOrIncompletePackages = (
  featureList: { name: string }[],
) => {
  return matchingOrMissingPackages(featureList, false)
}

export const findFullOrPartialMatchingPackages = (
  featureList: { name: string }[],
) => {
  return matchingOrMissingPackages(featureList, true)
}
